import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AdminUsersService } from '../../services/admin-users.service.';
import { AlertDialog } from '../../shared/dialogs/dialog';
import { environment } from './../../../environments/environment';
import { GlobalValidators } from './../../utils/validators';

@Component({
  selector: 'app-admin-reset-password',
  templateUrl: './admin-reset-password.component.html',
  styleUrls: ['./admin-reset-password.component.scss']
})
export class AdminResetPasswordComponent implements OnInit {
  sendVerificationForm: FormGroup;
  changePWType = false;
  siteKey = environment.siteKey;
  siginingInProgress;
  signinFormErrors;
  emailAddress: String;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private adminUserService: AdminUsersService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.emailAddress = params['email'];
    });
  }

  ngOnInit() {
    this.bindForm();
  }

  reset(form) {
    form.resetForm();
    this.bindForm();
  }

  bindForm() {
    this.sendVerificationForm = this.fb.group({
      username: [this.emailAddress || '', [Validators.required, GlobalValidators.email]]
    });
  }

  async sendVerification(form) {
    let email = form.value.username;
    this.adminUserService
      .resetUserPassword({ email: form.value.username })
      .then(data => {
        AlertDialog('A password reset link has been sent to ' + email, 'Password Reset', 'Ok');
        this.reset(form);
        this.router.navigate(['/admin-login']);
      })
      .catch(e => {
        AlertDialog('Error occured while processing your request ', 'Password Reset', 'Ok');
      });
  }

  displayPassword() {
    this.changePWType = !this.changePWType;
  }
}
